export class CleanTextHelper {
  static removeHtml(text: string, doc: Document) {
    let tmp = doc.createElement('DIV');
    tmp.innerHTML = tmp.textContent = text;
    return tmp.innerText || '';
  }
}
